module.exports = __webpack_public_path__ + "img/1.0442f122.gif";